// utils/formatDate.js

export function formatDate(dateInput: string | Date) {
    if (!dateInput) return ""; // Gestisce null, undefined o stringa vuota

    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    const formatter = new Intl.DateTimeFormat('en-GB', { year: 'numeric', month: '2-digit' });
    return formatter.format(date);
}
